export const engagementAppGroupIdGetAssetMetadata = "/engagement/:app_group_id/get_asset_metadata";
